var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/moreContentPage.f243a647.png","uri@2x": __webpack_public_path__ + "static/media/moreContentPage.1444bfae.png","uri@3x": __webpack_public_path__ + "static/media/moreContentPage.bd9631cb.png",
    width: 16,
    height: 16
});